import { Pipe, PipeTransform } from '@angular/core';

const REGEX_SPECIAL_CHARS = /[.*+?^${}()|[\]\\]/g;

@Pipe({
  name: 'highlight',
})
export class HighlightSearchPipe implements PipeTransform {
  transform(value: string, search: unknown): string {
    if (!value) {
      return '';
    }
    if (typeof search !== 'string' || !search) {
      return value;
    }
    const pattern = search.replace(REGEX_SPECIAL_CHARS, '\\$&');
    return value.replace(new RegExp(pattern, 'gi'), '<mark>$&</mark>');
  }
}
